module.exports = __webpack_public_path__ + "static/media/demon_slayer.30dd289d.png";